<template>
  <div class="item-list-container">
    <div class="tab-item">
      <div class="item" v-for="item in dataList" :key="item.id" @click="showDetailItem(item)">
        <div v-if="item.data_type === 'ugc_item'">
          <div v-if="item.type === 3" class="item-detail">
            <div class="cover-container cover-container-article">
              <img :src="item.cover_url" alt=""/>
              <div class="cover-mask">
                {{item.title}}
              </div>
            </div>
            <div class="article-desc-container">
              <div class="desc-article">{{item.description}}</div>
            </div>
          </div>
        </div>
        <div class="item-detail" v-if="item.data_type === 'good'">
          <div class="cover-container">
            <img :src="item.cover_url" alt=""/>
          </div>
          <div class="item-desc-container">
            <div class="desc">{{item.description}}</div>
            <div class="price">
              <span class="new-price"><span class="new-price-yuan">￥</span>{{item.price}}</span>
              <span v-if="item.price_prev && item.price_prev > item.price" class="old-price"> <del>￥{{item.price_prev}}</del> </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Tag} from "vant"
  import {ugcItemTypeUgcArticle} from "../../util/const";

  export default {
    name: "MixItemListTwoColGoods",
    components: {Tag},
    data() {
      return {}
    },
    props: {
      dataList: {
        type: Array,
      },
    },
    methods: {
      showDetailItem(item) {
        if (item.data_type === "good") {
          this.$router.push('/good/' + item.id);
        } else if (item.data_type === "ugc_item") {
          if (item.type === ugcItemTypeUgcArticle) {
            this.$router.push('/article/' + item.id);
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .item-list-container {
    background: #fff;
  }

  .tab-item {
    padding: 0 12px 5px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: #f2f2f2;
  }

  .tab-item .item {
    width: 48%
  }

  .item-detail {
    background-color: #fff;
    margin-top: 8px;
    /*-webkit-border-radius: 5px;*/
    /*-moz-border-radius: 5px;*/
    /*border-radius: 5px;*/
    /*overflow: hidden;*/
    width: 100%;

    .cover-container {
      position: relative;
      overflow: hidden;
      height: 180px;

      img {
        position: absolute;
        display: block;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);

        height: 100%;
        margin: 0 auto;
      }

      .cover-mask {
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.8), transparent);
        padding: 12px 8px 3px;
        color: white;
        min-width: 90%;
      }
    }

    .cover-container-article {
      height: 190px;
    }

    .article-desc-container {
      padding: 8px 8px 8px 8px;
      min-height: 36px;

      .desc-article {
        font-size: 12px;
        line-height: 18px;
        max-height: 36px;
        letter-spacing: 1px;
        color: rgba(0, 0, 0, 0.65);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden
      }
    }

    .item-desc-container {
      padding: 8px 8px 8px 8px;

      .desc {
        font-size: 12px;
        line-height: 18px;
        max-height: 36px;
        letter-spacing: 1px;
        color: rgba(0, 0, 0, 0.65);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden
      }
    }

    .price {
      font-size: 12px;
      margin-top: 10px;

      .new-price {
        color: #ff4c0a;
      }

      .new-price-yuan {
        font-size: 12px;
      }
    }

    .old-price {
      font-size: 12px;
      color: grey;
      margin-left: 6px;
    }

    .old-price del {
      color: grey;
    }
  }

  .article-item {
    margin: 8px 0px;
    overflow: hidden;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    display: flex;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    align-items: center;

    .title-container {
      flex: 1 1 auto;
      padding: 15px;
      width: 55%;
      line-height: 24px;
      color: rgba(52, 52, 52, 0.86);
    }

    .article-cover-container {
      width: 45%;
      flex: 0 0 auto;
      height: 130px;
      position: relative;
      overflow: hidden;

      img {
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        transform: translate(-50%, -50%);
      }
    }

  }

</style>
